export default __webpack_public_path__ + "static/media/Logo-Mark-1.484145d3.svg";